// extracted by mini-css-extract-plugin
export default {"container":"WeekDayPicker_container__IxRa1","chip":"WeekDayPicker_chip__RUntd","excludedDaysLabel":"WeekDayPicker_excludedDaysLabel__6FOxH"};